import React from 'react'

import Security from 'components/Security'

const SecurityPage: React.FC = () => {
  return <Security />
}

export default SecurityPage
